$(document).ready(function () {
  $('.submenu-btn').click(function () {
    $('#NavDrawer').addClass('submenu-open');
    $(this).parents('.mobile-nav__item').addClass('menu-active');
     $(this).parents('.mobile-nav__item').siblings().find('.mobile-nav__has-sublist').css('display','none');
  });

  $('.back_menu').click(function(){
     $('#NavDrawer').removeClass('submenu-open');
      $(this).parents('.mobile-nav__item').removeClass('menu-active');
      $(this).parents('.mobile-nav__item').siblings().find('.mobile-nav__has-sublist').css('display','table');
  })
});